import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  ToolbarImage: {
    height: '100px',
    width: '130px',
    paddingTop: '10px',
  },
  ToolbarContent: {
    height: '100px',
    padding: '10px',
  },
  headerText: {
    color: '#404040',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  headerDate: {
    color: '#a8a8a8',
    fontSize: '10px',
  },
  headerImage: {
    borderRadius: '3px',
  },
  list: {
    borderBottom: '2px solid #eaf4f8',
    backgroundColor: '#ffffff',
  },
  roomNotRead: {
    borderBottom: '2px solid #eaf4f8',
    backgroundColor: '#f2fbff',
  },
  roomActive: {
    borderBottom: '2px solid #eaf4f8',
    backgroundColor: '#ededed',
  },
  listTextNameNotRead: {
    fontWeight: 'bold',
    fontSize: '16px !important',
    color: '#404040',
  },
  listTextName: {
    fontWeight: '400',
    fontSize: '16px !important',
    color: '#404040',
  },
  listTextContent: {
    fontWeight: 'normal',
    fontSize: '12px',
    color: '#707070',
  },
  listTextContentNotRead: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#707070',
  },
  badgeDot: {
    backgroundColor: '#f74872',
    color: 'white',
  },
  marginAuto: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  divToTopic: {
    backgroundColor: '#eaf4f8',
  },
  buttonToTopic: {
    backgroundColor: '#eaf4f8',
    color: '#404040',
    height: '40px',
    borderRadius: 0,
  },
  gridDot: {
    flexBasis: 0,
  },
  listTitle: {
    fontSize: '12px',
  },
  dateEvent: {
    fontSize: '10px',
    color: '#f74872',
  },
  marginSearch: {
    margin: theme.spacing(1),
  },
  textField: {
    width: '100%',
  },
  searchInput: {
    height: '40px',
  },
  textContent: {
    overflow: 'hidden',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  listEmpty: {
    marginTop: '60%',
  },
  chatIconEmpty: {
    fontSize: '8rem',
    color: '#b6b6b6',
  },
  conversationsEmptyTitle: {
    fontSize: '16px',
    color: '#b6b6b6',
    fontWeight: '700',
  },
  conversationsEmptyContent: {
    fontSize: '16px',
    color: '#b6b6b6',
  },
  gridRoot: {
    flexGrow: 1,
  },
}))
